import { FC } from 'react';
import { Box, Divider } from '@chakra-ui/react';
import { TransferAludelForm } from './TransferAludelForm';
import { RenounceOwnershipForm } from './RenounceOwnershipForm';
import { RegisterVaultFactoryForm } from './RegisterVaultFactoryForm';
import { RemoveVaultFactoryForm } from './RemoveVaultFactoryForm';
import { ExtendedRewardProgram } from 'types';
import { RescueTokensForm } from './RescueTokensForm';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { rescueTokensSchema } from 'components/onboarding/deployment/formSchema';
import { PowerSwitchStatus } from 'api/blockchain/rewardProgram';

type Props = {
  program: ExtendedRewardProgram;
  programState?: PowerSwitchStatus;
};

export const TransferFormWrapper: FC<Props> = ({ program, programState }) => {
  const methods = useForm({ resolver: yupResolver(rescueTokensSchema) });

  return (
    <>
      <Box p={4}>
        <RegisterVaultFactoryForm
          programState={programState}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <RemoveVaultFactoryForm
          vaultFactories={program.rewardProgram.vaultFactories}
          programState={programState}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <TransferAludelForm aludelAbi={program.rewardProgram.abi} />
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <FormProvider {...methods}>
          <RescueTokensForm
            rewardPoolAddress={program.poolAddress}
            aludelAddress={program.rewardProgramAddress}
            aludelAbi={program.rewardProgram.abi}
            programState={programState}
          />
        </FormProvider>
      </Box>
      <Divider my={4} />
      <Box p={4}>
        <RenounceOwnershipForm
          contractAddress={program.rewardProgram.address}
          aludelAddress={program.rewardProgramAddress}
          aludelAbi={program.rewardProgram.abi}
        />
      </Box>
    </>
  );
};
